import { useSyncExternalStore } from 'react';

/**
 * "Agora" como fonte externa, e não como leitura solta no corpo do componente:
 * o relógio é impuro, e ler `Date.now()` durante a renderização deixa a tela
 * dessincronizada (a faixa de trial ficaria com a contagem de ontem).
 *
 * O valor é arredondado para o intervalo, então re-renderiza uma vez por
 * minuto — e não a cada frame.
 */
export function useAgora(intervaloMs = 60_000): number {
  return useSyncExternalStore(
    (avisar) => {
      const id = setInterval(avisar, intervaloMs);
      return () => clearInterval(id);
    },
    () => Math.floor(Date.now() / intervaloMs) * intervaloMs,
    () => 0,
  );
}

/** Dias inteiros que faltam até a data, nunca negativo. */
export function diasRestantes(ate: string | null | undefined, agora: number): number | null {
  if (!ate) return null;
  const alvo = new Date(ate).getTime();
  if (Number.isNaN(alvo)) return null;
  return Math.max(0, Math.ceil((alvo - agora) / 86_400_000));
}
